import {ROUTES_PATH} from "../../modules/utils/Constant";

export type TMenu = {
  name: string;
  uri: string;
  icon: string;
  code: string;
  description?: string;
  id?: number;
  disabled?: boolean;
  isMain?: boolean;
  order?: number;
  path: string;
  serviceCode?: string;
  classNameIcon?: string;
  subs?: TMenu[];
  [x: string]: any;
  hasBullet?: boolean;
  permission: string;
  ability: string;
};

export const listModule: TMenu[] = [
  {
    id: 1,
    code: "admission",
    name: "Xây dựng kế hoạch",
    description: "Xây dựng kế hoạch",
    icon: "",
    path: "/ADMISSION/",
    uri: "/build-plan",
    order: 1,
    orgId: null,
    parentId: null,
    isMain: true,
    disabled: false,
    uiComponent: null,
    subs: [],
    serviceCode: "oceantech-emr-server",
    permission: "default_permission",
    ability: "default_ability",
  },
  {
    id: 2,
    code: "admission",
    name: "Phân công báo cáo",
    description: "Phân công báo cáo",
    icon: "",
    path: "/REPORT_ASSIGNMENT/",
    uri: ROUTES_PATH.REPORT_ASSIGNMENT,
    order: 1,
    orgId: null,
    parentId: null,
    isMain: true,
    disabled: false,
    uiComponent: null,
    subs: [],
    serviceCode: "oceantech-emr-server",
    permission: "default_permission",
    ability: "default_ability",
  },
  {
    id: 3,
    code: "admission",
    name: "Báo cáo tiểu mục",
    description: "Báo cáo tiểu mục",
    icon: "",
    path: "/CRITERIA_REPORT/",
    uri: ROUTES_PATH.CRITERIA_REPORT,
    order: 3,
    orgId: null,
    parentId: null,
    isMain: true,
    disabled: false,
    uiComponent: null,
    subs: [],
    serviceCode: "oceantech-emr-server",
    permission: "default_permission",
    ability: "default_ability",
  },
  {
    id: 4,
    code: "admission",
    name: "Đánh giá báo cáo",
    description: "Đánh giá báo cáo",
    icon: "",
    path: "/EVALUATION_REPORT/",
    uri: ROUTES_PATH.EVALUATION_REPORT,
    order: 4,
    orgId: null,
    parentId: null,
    isMain: true,
    disabled: false,
    uiComponent: null,
    subs: [],
    serviceCode: "oceantech-emr-server",
    permission: "default_permission",
    ability: "default_ability",
  },
  {
    id: 5,
    code: "admission",
    name: "Khắc phục tiêu chí",
    description: "Khắc phục tiêu chí",
    icon: "",
    path: "/CORRECTIVE_SUBSECTION/",
    uri: ROUTES_PATH.CORRECTIVE_SUBSECTION,
    order: 5,
    orgId: null,
    parentId: null,
    isMain: true,
    disabled: false,
    uiComponent: null,
    subs: [],
    serviceCode: "oceantech-emr-server",
    permission: "default_permission",
    ability: "default_ability",
  },
  {
    id: 6,
    code: "categories",
    name: "Danh mục",
    description: "Danh mục",
    icon: "",
    path: "/CATEGORIES/",
    uri: "/categories",
    order: 1,
    orgId: null,
    parentId: null,
    isMain: true,
    disabled: false,
    uiComponent: null,
    subs: [],
    serviceCode: "oceantech-emr-server",
    permission: "default_permission",
    ability: "default_ability",
  },
];
